import { Routes } from '@angular/router';
import { AppRoutes } from '../core/enums/app-routes.enum';
import { authGuard } from '../core/guards/auth.guard';
import { noAuthGuard } from '../core/guards/no-auth.guard';
import { rootRedirectGuard } from '../core/guards/root-redirect.guard';

export const routes: Routes = [
  {
    path: '',
    pathMatch: 'full',
    canActivate: [rootRedirectGuard],
    children: [],
  },

  {
    path: AppRoutes.AUTH,
    canActivate: [noAuthGuard],
    children: [
      {
        path: AppRoutes.LOGIN,
        loadComponent: () =>
          import('./pages/login/login.page').then(m => m.LoginPage),
      },
      {
        path: AppRoutes.REGISTER,
        loadComponent: () =>
          import('./pages/register/register.page').then(m => m.RegisterPage),
      },
      {
        path: '',
        redirectTo: AppRoutes.LOGIN,
        pathMatch: 'full',
      },
    ],
  },

  {
    path: AppRoutes.APP,
    loadComponent: () =>
      import('./pages/app-shell/app-shell.page').then(m => m.AppShellPage),
    canActivate: [authGuard],
    children: [
      {
        path: '',
        loadChildren: () =>
          import('./tabs/tabs.routes').then(m => m.routes),
      },
      {
        path: 'about',
        loadComponent: () =>
          import('./pages/about/about.page').then(m => m.AboutPage),
      },
      {
        path: AppRoutes.WEB_VIEW,
        loadComponent: () =>
          import('./pages/pagina-web/pagina-web.page').then(m => m.PaginaWebPage),
      },
    ],
  },

  {
    path: '**',
    canActivate: [rootRedirectGuard],
    children: [],
  },
];
